import React, { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import Text from '@/components/ui/Text';
import Icon from '@/components/ui/Icon';
import { NotifyStudentsClassroom } from './NotifyStudentsModal.utils';

interface ClassroomCheckboxHeaderProps {
  alreadyJoinedStudentIds: number[];
  classroom: NotifyStudentsClassroom;
  isOpen: boolean;
}

const ClassroomCheckboxHeader = ({ alreadyJoinedStudentIds, classroom, isOpen }: ClassroomCheckboxHeaderProps) => {
  const { setValue, watch } = useFormContext();
  const ref = useRef<HTMLInputElement>();
  const classroomValues = watch(classroom.id.toString());
  const eligibleStudents = classroom.students.filter(s => !alreadyJoinedStudentIds.includes(s.id));
  const hasStudents = eligibleStudents.length > 0;
  const isChecked = classroomValues.length === eligibleStudents.length && hasStudents;

  useEffect(() => {
    if (!ref.current) return;
    ref.current.indeterminate = classroomValues.length > 0 && !isChecked;
  }, [classroomValues.length, isChecked]);

  return (
    <div className="tw-flex tw-items-center tw-gap-3">
      <input
        ref={ref}
        checked={isChecked}
        className="tw-w-5 tw-h-5 tw-shrink-0"
        disabled={!hasStudents}
        type="checkbox"
        onChange={() => {
          const studentIds = eligibleStudents.map(s => s.id.toString());

          setValue(classroom.id.toString(), isChecked ? [] : studentIds);
        }}
        onClick={e => e.stopPropagation()}
      />
      <div className="tw-grow tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-flex-col">
          <Text spacing="sm" weight="semibold">{`${classroom.period} - ${classroom.name}`}</Text>
          <Text className="!tw-text-dark-grey" size="sm" spacing="sm">{`${classroom.students.length} students`}</Text>
        </div>
        <div className="tw-shrink-0">
          <Icon
            icon={isOpen ? 'ChevronDown' : 'ChevronRight'}
            size={20}
          />
        </div>
      </div>
    </div>
  );
};

export default ClassroomCheckboxHeader;
